<template>
  <div class="tagBox__div">
    <span style="margin-right: 10px">
      所在区域：
    </span>
    <el-button v-for="i in tags" :key="i.value" plain size="small" :type="active === i.value ? 'primary': ''" @click="selectTag(i.value)">
      {{i.title}}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "Tags",
  data () {
    return {
      active: 0,
      tags: [
        {
          value: 0,
          title: '全部'
        },
        {
          value: 1,
          title: '物流签收',
        },
        {
          value: 2,
          title: '简单检品',
        },
        {
          value: 3,
          title: '详细检查',
        },
        {
          value: 4,
          title: '成品区',
        },
        {
          value: 5,
          title: '已发货',
        },
        {
          value: 6,
          title: '贴标商品',
        },
        {
          value: 7,
          title: '组合商品',
        },
        {
          value: 8,
          title: '调拨分拣',
        },
        {
          value: 9,
          title: '次品',
        },
        {
          value: 10,
          title: '异常',
        },
      ]
    }
  },
  mounted() {
    this.$emit('search', this.active)
  },
  methods: {
    selectTag: function (v) {
      this.active = v
      this.$emit('search', this.active)
    }
  }
 }
</script>

<style scoped>
.tagBox__div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
</style>